interface ContactCardItem {
  icon: string;
  label: string;
  value: string;
  desc: string;
  href: string;
}

const items: ContactCardItem[] = [
  {
    icon: "ri-shield-check-line",
    label: "内容更正与事实核对",
    value: "contact@guatian-report.com",
    desc: "如果你发现某篇盘点存在时间、数据或表述偏差，附上公开链接会帮助我们更快核实。",
    href: "mailto:contact@guatian-report.com",
  },
  {
    icon: "ri-lightbulb-line",
    label: "线索投稿",
    value: "tips@guatian-report.com",
    desc: "欢迎提供假期前后的公开热点线索，我们更关注有出处、可交叉验证的信息。",
    href: "mailto:tips@guatian-report.com",
  },
  {
    icon: "ri-share-forward-line",
    label: "转载与内容合作",
    value: "contact@guatian-report.com",
    desc: "注明来源与原文链接可自由引用观点，整篇转载与商业合作请提前沟通。",
    href: "mailto:contact@guatian-report.com",
  },
];

export default function ContactCards() {
  return (
    <div className="space-y-4">
      {items.map((item) => (
        <a
          key={item.label}
          href={item.href}
          className="group flex cursor-pointer items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100">
            <i className={`${item.icon} text-lg text-primary-700`} />
          </span>
          <span className="flex-1">
            <span className="flex flex-wrap items-center gap-2">
              <span className="font-heading text-base font-bold text-foreground-950">{item.label}</span>
              <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">
                两个工作日内回复
              </span>
            </span>
            <span className="mt-1 block text-sm font-medium text-primary-600">{item.value}</span>
            <span className="mt-2 block text-sm leading-relaxed text-foreground-600">{item.desc}</span>
          </span>
          <i className="ri-arrow-right-line mt-1 shrink-0 text-foreground-400 transition-transform group-hover:translate-x-0.5" />
        </a>
      ))}
    </div>
  );
}